// check if category has the following pattern: category-<NUMBERS>
export default (category: string) => {
  const regex = /^category-\d+$/
  return regex.test(category) ? 'category' : 'tag'
}
